<template>
    <v-list-item :to="{ name: 'M_Keypads' }" :disabled="disabled">
        <v-list-item-icon>
            <v-icon>mdi-dots-grid</v-icon>
        </v-list-item-icon>
        
        <v-list-item-content>
            <v-list-item-title>Keypads</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'mNavItemKeypads',
    props: {
        disabled: Boolean,
    }
}
</script>